import { Box, Typography, useTheme } from '@mui/material';
import { useCreateResource } from '_api';
import { ResourcePayload } from '_api/types';
import { AdminRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { DefaultNewResource } from '_constants/object-templates';
import { TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import { ResourceForm } from 'components/organisms/forms';
import React, { useState } from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useNavigateTo } from 'utils';

export const AddResource = () => {
  const theme = useTheme();
  const navigate = useNavigateTo();
  const { mutateAsync: createResource } = useCreateResource();
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const onBack = () => {
    history.back();
  };

  const onSubmit = (submitResource: ResourcePayload) => {
    createResource(submitResource)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => {
            navigate(AdminRouteMap.LIBRARY);
          }, 1500);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setErrorMessage(
            'Unexpected error occured. Please refresh the page and try again.',
          );
        } else if (error.message) {
          setErrorMessage(`ERROR: ${error.message}`);
        } else {
          setErrorMessage('Unexpected error. Please Try again.');
        }
      });
  };

  return (
    <Box style={{ padding: 0 }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Add Resource
        </Typography>
        <TextButton
          onClick={onBack}
          sx={{ color: theme.palette.primary.main, marginBottom: '10px', paddingLeft: 0 }}
        >
          <IoArrowBackOutline />
          BACK
        </TextButton>
      </Box>
      <ResourceForm
        disableAll={showSuccess}
        initValue={DefaultNewResource}
        onBack={onBack}
        onSubmit={onSubmit}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Resource successfully create'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </Box>
  );
};
